<div [formGroup]="parent" class="col-md-12 form-field"
  [ngClass]="{'content-wrapper':(!defaultStyle && !lifestyleClass),'clear-all':(defaultStyle || lifestyleClass), 
  'margin-top-30':lifestyleClass,
  'has-error': parent.get(controlName).touched && parent.get(controlName).errors,'opacity':(disable), 'pointer-events-none':disable}">
  @if (questionConfig.isSafetyQuestion) {
    <app-yellow-tag></app-yellow-tag>
  }
  <fieldset class="fieldset" role="group"
    [attr.aria-invalid]="(parent.get(controlName).touched && parent.get(controlName).errors && !questionConfig.disabled) ? true : false"
    [attr.aria-labelledby]="(parent.get(controlName).touched && parent.get(controlName).errors && !questionConfig.disabled) ? controlName+'-error' : childId">
    <legend class="fieldset-label" class="visuallyhidden">Group label</legend>
    <div class="col-md-12 clear-all margin-top-30px">
      @if (questiontextRequired) {
        <span id="{{childId}}" class="question-style"
        [ngClass]="{'form-label-fullwidth':defaultStyle, 'risk-ques-style': questionConfig.isSafetyQuestion, 'normal-ques-style': !questionConfig.isSafetyQuestion, 
    'font-size-16': (router.url === '/home/your-personal-details' || router.url === '/home/registration' || applyStyle) }" [innerHTML]="questionConfig.questionStatement"></span>
      }
      @if (questionConfig.infoIconFlag) {
        <div class="info-icon d-view">
          <app-tool-tip-notification [uwQuesForWA]="givenQuestion" (lifestyleInfoEmitter)="lifestyleInfoReceiver($event)"
            (pensionWiseInfoEmitter)="pensionWiseInfoReceiver($event)"
            (letterPackInfoEmitter)="letterPackInfoIcon($event)" (UKResidentInfoEmitter)='UKResidentInfoReceiver($event)'
            (dependentContinueToPayInfoEmitter)="dependentContinueToPayInfoReceiver($event)"
            (riskTaxEmitter)="riskTaxReceiver($event)" (riskInflationEmitter)="riskInflationReceiver($event)"
            (riskLongTermCareEmitter)="riskLongTermCareReceiver($event)"
            (riskDebtMgmtEmitter)="riskDebtMgmtReceiver($event)"
            (riskOverallReturnEmitter)="riskOverallReturnReceiver($event)" (consentEmitter)="consentReceiver($event)"
            (lifetimeAllowanceEmitter)="lifetimeAllowanceReceiver($event)"
            (pensionCreditEmitter)="pensionCreditReceiver($event)"
            (benefitGuaranteedEmitter)="benefitGuaranteedReceiver($event)"
            (lumpSumAllowanceEmitter)="lumpSumAllowanceReceiver($event)"
            (lsaProtectionEmitter)="lsaProtectionReceiver($event)" [childId]="controlName"
            [tooltipName]="controlName+'_tooltip'" class="col-sm-1 padding-for-toolTip"
            [tooltipData]="questionConfig.infoIconData" [prodCode]="productCode"
          (displayMobileTooltipEmitter)="displayMobileTooltipReceiver()"></app-tool-tip-notification>
        </div>
      }
    </div>
    <div class="col-md-12 clear-all mt-view">
      @if (questionConfig.infoIconFlag) {
        <div class="info-icon">
          <app-tool-tip-notification [uwQuesForWA]="givenQuestion" (lifestyleInfoEmitter)="lifestyleInfoReceiver($event)"
            (pensionWiseInfoEmitter)="pensionWiseInfoReceiver($event)"
            (letterPackInfoEmitter)="letterPackInfoIcon($event)" (UKResidentInfoEmitter)='UKResidentInfoReceiver($event)'
            (dependentContinueToPayInfoEmitter)="dependentContinueToPayInfoReceiver($event)"
            (riskTaxEmitter)="riskTaxReceiver($event)" (riskInflationEmitter)="riskInflationReceiver($event)"
            (riskLongTermCareEmitter)="riskLongTermCareReceiver($event)"
            (riskDebtMgmtEmitter)="riskDebtMgmtReceiver($event)"
            (riskOverallReturnEmitter)="riskOverallReturnReceiver($event)" (consentEmitter)="consentReceiver($event)"
            (lifetimeAllowanceEmitter)="lifetimeAllowanceReceiver($event)"
            (pensionCreditEmitter)="pensionCreditReceiver($event)"
            (benefitGuaranteedEmitter)="benefitGuaranteedReceiver($event)"
            (lumpSumAllowanceEmitter)="lumpSumAllowanceReceiver($event)"
            (lsaProtectionEmitter)="lsaProtectionReceiver($event)" [childId]="controlName"
            [tooltipName]="controlName+'_tooltip'" class="col-sm-1 padding-for-toolTip"
            [tooltipData]="questionConfig.infoIconData" [prodCode]="productCode"
          (displayMobileTooltipEmitter)="displayMobileTooltipReceiver()"></app-tool-tip-notification>
        </div>
      }
    </div>
    <div class="col-md-12 col-sm-11 p-0 margint-30 btn-div btn-border-black"
      [ngClass]="{'clear-all':!questiontextRequired}">
      <div [ngClass]="childId && childId === 'currentDate'  ? 'button-label-flex' : 'flex-button'">
        <app-question-radio-button [defaultStyle]="defaultStyle" (radioBtnClickHandler)="toggleContainer($event, true)"
          [config]="radioButtonGroupConfig" (blurHandler)="onBlurRadioButton()"
          [isbuttonViewChanged]="isButtonAlignToBeChanged">
        </app-question-radio-button>
        @if (childId && childId === 'currentDate') {
          <label _ngcontent-kat-c67="" class="form-label" id="lbl-productOptions-startDate" for="productOptions-startDate">Or choose
          a date</label>
        }
      </div>
      @if (childId && childId === 'currentDate') {
        <div  [ngClass]="(!isdateReq)? 'col-md-12 clear-all flex-date-container':''" >
          @if (isdateReq) {
            <div class="col-md-12 clear-all margin-top-2 flex-50 ">
              <app-date-input (blurHandler)="checkDataChange($event)" [pageName]="'productOptions'" [parent]="parent"
                formControlName="startDate" [controllerData]="controllerData" [allowFutureData]="true"
                [startDateAgeRangeConfigObj]="startDateAgeRangeConfigObj"
                [commencementDateConfigObj]="commencementDateConfigObj">
              </app-date-input>
            </div>
          } @else {
            <div class="col-md-12 clear-all margin-top-left-2 flex-50 ">
              <app-day-month-year-dropdown (blurHandler)="checkDataChange($event)" [pageName]="'productOptions'"
                [parent]="parent" [controllerData]="controllerData" formControlName="startDate" [minValue]="'0.0'"
                [maxValue]="'0.3'" [allowFutureDate]="true" [date]="buttonPressed"
                [startDateAgeRangeConfigObj]="startDateAgeRangeConfigObj"
                [commencementDateConfigObj]="commencementDateConfigObj">
              </app-day-month-year-dropdown>
            </div>
          }
        </div>
      }
    </div>

  </fieldset>
  @if (questionInfo && questionInfo !== '') {
    <div class="question-info col-md-12 p-0 margintop-30"
      [ngClass]="questionInfoClass" id="questionInfo">
      <p [id]="childId+'-'+questionCode+'-data'" [innerHTML]="questionInfo" aria-live="polite" role="alert">
        <!-- <ng-container *ngIf="childId === 'claimPensionRisk' && (questionCode === 'N' || questionCode === 'U')">
        <a href="//www.gov.uk/browse/benefits" class="a-color"  target="_blank">{{questionConfig.browseBenefitsLink}}</a>{{questionConfig.dot}}
      </ng-container> -->
    </p>
  </div>
}
@if (parent.get(controlName).touched
  &&
  parent.get(controlName).errors && !questionConfig.disabled) {
  <div [ngClass]="{'margin-bottom-16': parent.get(controlName).errors.invalid}" class="col-md-12 form-validation-error"
    >
    <i class="icon icon-error" aria-hidden="true"></i>
    @if (parent.get(controlName).errors.required) {
      <p [id]="controlName+'-error'" aria-hidden="false" role="error">
        {{showMandatoryError()}}
      </p>
    }
    @if (parent.get(controlName).errors.invalid) {
      <p [id]="controlName+'-error'">{{questionConfig.invalidDealPartner}}
      </p>
    }
    @if (parent.get(controlName).errors.inValidTransferType) {
      <p [id]="controlName+'-error'">
        {{questionConfig.inValidTransferType}}
      </p>
    }
    @if (parent.get(controlName).errors.invalidTaxfree) {
      <p [id]="controlName+'-error'">
        {{questionConfig.invalidTaxfree}}
      </p>
    }
  </div>
}

</div>